<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11.5" stroke="#000"/>
  <path stroke="#000" d="M14.666 7l-5 5 5 5"/>
</svg>
